import { useEffect, useState } from 'react';

/**
 * Höhe der Bildschirmtastatur (px), solange `isActive`.
 *
 * iOS Safari verkleinert beim Tippen nur den sichtbaren Bereich
 * (`visualViewport`), nicht das Layout — ein unten verankertes Eingabefeld läge
 * sonst hinter der Tastatur. Die „Wohin?"-Suche sitzt bewusst unten (Daumen),
 * darum hebt sie sich um diesen Wert an. Ohne `visualViewport` (ältere
 * Browser, jsdom) bleibt es bei 0.
 */
export function useKeyboardInset(isActive: boolean): number {
  const [inset, setInset] = useState(0);
  useEffect(() => {
    const viewport = typeof window !== 'undefined' ? window.visualViewport : null;
    if (!isActive || !viewport) {
      setInset(0);
      return;
    }
    const update = () => setInset(Math.max(0, Math.round(window.innerHeight - viewport.height - viewport.offsetTop)));
    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
    };
  }, [isActive]);
  return inset;
}
